"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _reactDom = require("react-dom");

var _constants = require("../../constants");

var _lodash = require("lodash");

var _reactBootstrap = require("react-bootstrap");

var _StatusWrapper = require("../StatusWrapper");

var _StatusWrapper2 = _interopRequireDefault(_StatusWrapper);

var _ForgotPassword = require("./ForgotPassword");

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _reactIntl = require("react-intl");

var _reactCssModules = require("react-css-modules");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _tcombForm = require("tcomb-form");

var _tcombForm2 = _interopRequireDefault(_tcombForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var styles = require("./GenericLoginPage.less");

var Form = _tcombForm2.default.form.Form;
// LoginStateSchema
var LoginStateSchema = _tcombForm2.default.struct({ username: _tcombForm2.default.Str, password: _tcombForm2.default.Str, shouldRememberUser: _tcombForm2.default.Bool });
var LoginPage = function (_React$Component) {
    _inherits(LoginPage, _React$Component);

    function LoginPage(props) {
        _classCallCheck(this, LoginPage);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(LoginPage).call(this, props));

        _this.onInputChange = function (loginState) {
            if (_this.state.inputWasMade === false) {
                _this.setState({ inputWasMade: true });
            }
            _this.setState(loginState);
        };
        _this.onFormSubmit = function (e) {
            e.preventDefault();
            var data = _this.refs.form.getValue();
            var dispatch = _this.props.dispatch;

            if (data) {
                // data is valid, try to login...
                dispatch(_this.props.login(data.username, data.password, data.shouldRememberUser));
            }
        };
        _this.onForgotPasswordClicked = function (e) {
            e.preventDefault();
            _this.setState({
                isForgotPasswordModalOpen: true
            });
        };
        _this.onModalClose = function () {
            _this.setState({
                isForgotPasswordModalOpen: false
            });
        };
        _this.onDismissError = function (e) {
            var dispatch = _this.props.dispatch;

            dispatch(_this.props.dismissError());
            _this.setState({ password: "" });
        };
        _this.onResetPasswordSuccess = function () {
            _this.setState({
                isPasswordResetSuccessBannerVisible: true
            });
            _this.onModalClose();
        };
        _this.onDismissSuccessResetEmail = function () {
            _this.setState({
                isPasswordResetSuccessBannerVisible: false
            });
        };
        // set the initialValues of this internal state...
        _this.state = {
            username: props.auth.username,
            password: "",
            shouldRememberUser: props.auth.shouldRememberUser,
            inputWasMade: false,
            isForgotPasswordModalOpen: false,
            isPasswordResetSuccessBannerVisible: false
        };
        return _this;
    }

    _createClass(LoginPage, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            // if the current username in the underlying reducer did change while our component state does not have
            // this can happen as rehydration is trigger later after the constructor of this component already ran (setting our internal component state)
            if (nextProps.auth.username && nextProps.auth.username.length > 0 && this.state.inputWasMade === false) {
                var username = nextProps.auth.username;
                this.setState({ username: username });
                // username is now set, focus the password field directly on the dom (after the new render through setTimeout)!
                setTimeout(function () {
                    try {
                        (0, _reactDom.findDOMNode)(_this2.refs.form.refs.input.refs.password).getElementsByTagName("input")[0].focus();
                    } catch (e) {}
                });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var auth = this.props.auth;

            var SchemaOptions = {
                fields: {
                    username: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "schema.username" }),
                        error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "validationError.username" })),
                        attrs: {
                            autoFocus: (0, _lodash.isString)(auth.username) === false
                        }
                    },
                    password: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "schema.password" }),
                        type: "password",
                        error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "validationError.Password" })),
                        attrs: {
                            autoFocus: (0, _lodash.isString)(auth.username) && auth.username.length > 0 // autofocus password if username is set on first render
                        }
                    },
                    shouldRememberUser: {
                        label: React.createElement(_reactIntl.FormattedMessage, { id: "schema.shouldRememberUser" })
                    }
                }
            };
            var customErrorText = null;
            if (auth.errorStatus === _constants.FETCH_STATUS_UNPROCESSABLE_ENTITY) {
                customErrorText = React.createElement(_reactIntl.FormattedMessage, { id: "authProcess.wrongCredentials", values: {
                        error: auth.errorStatus
                    } });
            } else if (auth.errorStatus === _constants.FETCH_STATUS_TIMEOUT) {
                customErrorText = React.createElement(_reactIntl.FormattedMessage, { id: "authProcess.timeout", values: {
                        error: auth.errorStatus
                    } });
            } else if (auth.errorStatus === _constants.FETCH_STATUS_UNAUTHORIZED || auth.errorStatus === _constants.FETCH_STATUS_FORBIDDEN) {
                customErrorText = React.createElement(_reactIntl.FormattedMessage, { id: "authProcess.globalSecurityError", values: {
                        error: auth.errorStatus
                    } });
            }
            var formatMessage = this.props.intl.formatMessage;

            var passwordSuccessResetBanner = null;
            if (this.state.isPasswordResetSuccessBannerVisible === true) {
                passwordSuccessResetBanner = React.createElement(_reactBootstrap.Alert, { styleName: "passwordSuccessResetBanner", bsStyle: "success", onDismiss: this.onDismissSuccessResetEmail }, React.createElement(_reactIntl.FormattedMessage, { id: "forgotPassword.success" }));
            }
            return React.createElement("div", { styleName: "wrapper" }, React.createElement(_reactBootstrap.Grid, { fluid: true }, passwordSuccessResetBanner, React.createElement(_reactBootstrap.Row, { styleName: "login-row" }, React.createElement(_reactBootstrap.Col, { xs: 12, sm: 6, md: 6, lg: 4, xsOffset: 0, smOffset: 3, mdOffset: 3, lgOffset: 4 }, React.createElement(_StatusWrapper2.default, { isLoading: auth.isLoading, error: auth.error, errorText: customErrorText, loadingText: formatMessage({ id: "authProcess.loading" }), onDismissError: this.onDismissError }, React.createElement(_reactBootstrap.Well, null, React.createElement("form", { onSubmit: this.onFormSubmit, autoCorrect: "off", autoCapitalize: "none", formMethod: "post" }, React.createElement(Form, { ref: "form", onChange: this.onInputChange, type: LoginStateSchema, options: SchemaOptions, value: this.state }), React.createElement("aside", null, React.createElement(_reactBootstrap.Button, { disabled: auth.isLoading, type: "submit", bsStyle: "primary" }, React.createElement(_reactIntl.FormattedMessage, { id: "login" })), React.createElement(_reactBootstrap.Button, { styleName: "forgot-password-btn", bsStyle: "link", onClick: this.onForgotPasswordClicked }, React.createElement(_reactIntl.FormattedMessage, { id: "login.page.forgotPassword.button" }))))))))), React.createElement(_ForgotPassword2.default, { showModal: this.state.isForgotPasswordModalOpen, onClose: this.onModalClose, onResetPasswordSuccess: this.onResetPasswordSuccess, client: this.props.client, email: this.state.username }));
        }
    }]);

    return LoginPage;
}(React.Component);
LoginPage = __decorate([_reactIntl.injectIntl, (0, _reactCssModules2.default)(styles)], LoginPage);
exports.default = LoginPage;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/auth/GenericLoginPage.tsx
 ** module id = 1308
 ** module chunks = 0
 **/